'use client'

import { ChevronDown, User } from 'lucide-react'

import { renderClientTemplate } from '@/lib/content-standard/client-template'
import type { SearchWidgetCopy } from '@/lib/search-widget/copy'
import { cn } from '@/lib/utils'

/** Seat-count options (1–8). */
const PASSENGER_OPTIONS = Array.from({ length: 8 }, (_, i) => i + 1)

interface PassengerSelectProps {
    passengerCount: SearchWidgetCopy['passengerCount']

    passengers: SearchWidgetCopy['passengers']
    value: number
    onChange: (value: number) => void
    /** Drop the standalone border on mobile when sitting inside the grouped field card. */
    grouped?: boolean
    /** Keep the grouped mobile presentation at every width (no md: borders). */
    forceMobile?: boolean
    className?: string
}

// Hex values match the other widget fields; the brand ramps are not in the theme token
// set, so a move to tokens is a widget-wide change rather than a per-component one.
export const PassengerSelect = ({
    passengerCount,
    passengers,
    value,
    onChange,
    grouped = false,
    forceMobile = false,
    className,
}: PassengerSelectProps) => {
    return (
        <div className={cn('relative flex items-center', className)}>
            <User
                aria-hidden="true"
                className="pointer-events-none absolute left-3 h-5 w-5 text-[#2e3033]"
            />
            <select
                aria-label={passengers.text}
                value={String(value)}
                onChange={(e) => onChange(Number(e.target.value))}
                className={cn(
                    'h-12 w-full appearance-none bg-white pr-9 pl-9 text-sm text-[#2e3033] focus:outline-none',
                    grouped && forceMobile && 'border-0',
                    grouped &&
                        !forceMobile &&
                        'border-0 md:rounded-[7px] md:border md:border-[#d9dee5] md:focus:border-[#00bfd5]',
                    !grouped && 'rounded-[7px] border border-[#d9dee5] focus:border-[#00bfd5]',
                )}
            >
                {PASSENGER_OPTIONS.map((n) => (
                    <option key={n} value={n}>
                        {renderClientTemplate(passengerCount, { count: n })}
                    </option>
                ))}
            </select>
            <ChevronDown
                aria-hidden="true"
                className="pointer-events-none absolute right-3 h-4 w-4 text-[#8c939c]"
            />
        </div>
    )
}
